import {Directive, HostBinding, Input} from '@angular/core';

@Directive({
    selector: '[ui-loading]',
    standalone: false,
})
export class UiLoading {
    @HostBinding('class.ui-loading') isLoading = false;

    @Input('ui-loading') set loading(value: 'true' | 'false' | boolean) {
        this.isLoading = (value === 'true' || value === true);
    }
}
